module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result bg-black dker"
  }, [_c('div', {
    staticClass: "result-title"
  }, [_c('h1', [_vm._v("RELATÓRIO MÉDIA DE RECUPERAÇÃO X FIPE")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.type))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.period))])]), _vm._v(" "), _c('div', {
    staticClass: "line-graph"
  }, [_c('div', {
    staticClass: "col1"
  }, [_c('table', {
    staticClass: "tbl-result"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.data), function(v) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(v.comitente))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(v.percentualFipe))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col2"
  }, [_c('graph-media-fipe', {
    attrs: {
      "data": _vm.data
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Comitente")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("% FIPE")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69e100a9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/relatorios-basicos/components/Result.vue
// module id = 1741
// module chunks = 17